import React from "react";
import { CheckCircle2 } from "lucide-react";

const WhyChooseRevibe = () => {
  const features = [
    "No travel, no excuses—just open your phone.",
    "Affordable plans for everyone.",
    "Trainers guide form & posture in live sessions.",
    "Fun, engaging formats (dance, yoga, cardio, HIIT).",
  ];

  return (
    <section className="w-full bg-gradient-to-b from-white to-[#F9FAFB] py-16 px-6 lg:px-12">
      <div className="max-w-6xl mx-auto text-center">
        {/* Heading */}
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
          Why People Choose{" "}
          <span className="text-[#C5F122]">Revibe</span> Over Gyms
        </h2>

        {/* Subtitle */}
        <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-12">
          Experience a new way to stay fit with convenience, affordability, and
          fun.
        </p>

        {/* Feature list */}
        <div className="grid md:grid-cols-2 gap-8 text-left">
          {features.map((feature, index) => (
            <div
              key={index}
              className="flex items-start gap-4 bg-white shadow-md rounded-2xl p-6 hover:shadow-lg transition"
            >
              {/* Icon with brand color */}
              <CheckCircle2 className="w-7 h-7 text-[#758AA9] flex-shrink-0" />
              <p className="text-gray-800 text-lg">{feature}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseRevibe;
